/*
 * @Author: limin
 * @Date: 2019-08-26 18:02:41
 * @Last Modified by: limin
 * @Last Modified time: 2019-11-06 10:00:08
 */

import axios from './axios'
import sign from './request.sign'
import RequestMethods from './request.methods'
import { sys as system } from '@/utils'

const request = (params = {}, method = RequestMethods.POST, noSignAttr = []) => {
  const {source,sessionId,userId} = system.ids
  let p = Object.assign({timestamp:new Date().getTime(),source,sessionId,userId},params,window.vm.$config)
  return axios[method]('router',sign(p, noSignAttr))
}
export default request
